"use client";

import { useNavigate } from "react-router-dom";
import { ArrowRightIcon, CheckIcon, SparklesIcon } from "@heroicons/react/24/outline";

export default function CTA() {
    const navigate = useNavigate();

    return (
        <section className="relative overflow-hidden bg-[#F3F8FF] py-14 sm:py-18 lg:py-24">

            {/* =========================================================
                BACKGROUND DECORATION
            ========================================================== */}

            {/* Top Red Glow */}
            {/* <div
                className="
                    pointer-events-none
                    absolute
                    inset-x-0
                    top-0
                    h-[180px]
                    bg-gradient-to-b
                    from-[#8B0000]/25
                    via-[#8B0000]/10
                    to-transparent
                "
            /> */}

            {/* Bottom Red Glow */}
            {/* <div
                className="
                    pointer-events-none
                    absolute
                    inset-x-0
                    bottom-0
                    h-[180px]
                    bg-gradient-to-t
                    from-[#8B0000]/20
                    via-[#8B0000]/8
                    to-transparent
                "
            /> */}

            {/* Gold Ambient Glow */}
            <div
                className="
                    pointer-events-none
                    absolute
                    -left-32
                    top-1/2
                    h-[420px]
                    w-[420px]
                    -translate-y-1/2
                    rounded-full
                    bg-[#D7A74A]/10
                    blur-[100px]
                "
            />

            {/* Teal Ambient Glow */}
            <div
                className="
                    pointer-events-none
                    absolute
                    -right-40
                    top-1/3
                    h-[500px]
                    w-[500px]
                    rounded-full
                    bg-[#0B5552]/10
                    blur-[120px]
                "
            />

            {/* Decorative Gold Ring */}
            <div
                className="
                    pointer-events-none
                    absolute
                    -right-24
                    -top-24
                    h-[280px]
                    w-[280px]
                    rounded-full
                    border
                    border-[#D7A74A]/20
                "
            />

            <div
                className="
                    pointer-events-none
                    absolute
                    -right-12
                    -top-12
                    h-[180px]
                    w-[180px]
                    rounded-full
                    border
                    border-[#D7A74A]/15
                "
            />


            {/* =========================================================
                MAIN CONTAINER
            ========================================================== */}

            <div className="relative z-10 mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 xl:px-16">

                <div
                    className="
                        relative
                        overflow-hidden
                        rounded-[28px]
                        border
                        border-[#D8E1E8]
                        bg-white
                        shadow-[0_25px_80px_rgba(11,85,82,0.12)]
                    "
                >

                    {/* =================================================
                        INNER DARK PANEL
                    ================================================== */}

                    <div className="relative overflow-hidden bg-[#0B5552]">

                        {/* Dark Background Glow */}
                        <div
                            className="
                                pointer-events-none
                                absolute
                                inset-0
                                bg-[radial-gradient(circle_at_85%_20%,rgba(215,167,74,0.18),transparent_32%),radial-gradient(circle_at_10%_90%,rgba(139,0,0,0.20),transparent_35%)]
                            "
                        />

                        {/* Gold Top Line */}
                        <div
                            className="
                                absolute
                                left-0
                                top-0
                                h-[2px]
                                w-full
                                bg-gradient-to-r
                                from-transparent
                                via-[#D7A74A]
                                to-transparent
                            "
                        />

                        <div
                            className="
                                relative
                                grid
                                lg:grid-cols-[1.2fr_0.8fr]
                            "
                        >

                            {/* =================================================
                                LEFT CONTENT
                            ================================================== */}

                            <div
                                className="
                                    relative
                                    flex
                                    flex-col
                                    justify-center
                                    px-6
                                    py-12
                                    sm:px-10
                                    sm:py-14
                                    lg:px-14
                                    lg:py-16
                                    xl:px-20
                                    xl:py-20
                                "
                            >

                                {/* Eyebrow */}
                                <div className="mb-6 flex items-center gap-3">

                                    <span className="h-px w-10 bg-[#D7A74A]" />

                                    <span
                                        className="
                                            text-[10px]
                                            font-semibold
                                            uppercase
                                            tracking-[0.32em]
                                            text-[#D7A74A]
                                            sm:text-[11px]
                                        "
                                    >
                                        Your Dubai Stay Awaits
                                    </span>

                                </div>


                                {/* Heading */}
                                <h2
                                    className="
                                        max-w-2xl
                                        font-serif
                                        text-4xl
                                        font-medium
                                        leading-[1.08]
                                        tracking-tight
                                        !text-white
                                        sm:text-5xl
                                        lg:text-6xl
                                        xl:text-7xl
                                    "
                                >
                                    Find a stay
                                    <span className="block text-[#D7A74A]">
                                        worth remembering.
                                    </span>
                                </h2>


                                {/* Description */}
                                <p
                                    className="
                                        mt-6
                                        max-w-xl
                                        text-sm
                                        leading-7
                                        text-white/70
                                        sm:text-base
                                        sm:leading-8
                                    "
                                >
                                    From iconic beachfront resorts to elegant city
                                    hotels, discover beautiful places to stay in Dubai
                                    at rates designed around your trip.
                                </p>


                                {/* =================================================
                                    CTA BUTTONS
                                ================================================== */}

                                <div
                                    className="
                                        mt-8
                                        flex
                                        flex-col
                                        gap-3
                                        sm:flex-row
                                    "
                                >

                                    {/* Primary */}
                                    <button
                                        type="button"
                                        onClick={() => navigate("/hotels")}
                                        className="
                                            group
                                            inline-flex
                                            min-h-[52px]
                                            items-center
                                            justify-center
                                            gap-3
                                            rounded-xl
                                            bg-[#D7A74A]
                                            px-7
                                            text-sm
                                            font-semibold
                                            text-[#0B5552]
                                            shadow-[0_10px_30px_rgba(215,167,74,0.20)]
                                            transition-all
                                            duration-300
                                            hover:-translate-y-1
                                            hover:bg-[#E2B65A]
                                            hover:shadow-[0_15px_35px_rgba(215,167,74,0.30)]
                                        "
                                    >
                                        Explore Dubai Hotels

                                        <ArrowRightIcon
                                            className="
                                                h-4
                                                w-4
                                                transition-transform
                                                duration-300
                                                group-hover:translate-x-1
                                            "
                                        />
                                    </button>


                                    {/* Secondary */}
                                    <button
                                        type="button"
                                        onClick={() => navigate("/hotels")}
                                        className="
                                            inline-flex
                                            min-h-[52px]
                                            items-center
                                            justify-center
                                            gap-2
                                            rounded-xl
                                            border
                                            border-white/25
                                            bg-white/5
                                            px-7
                                            text-sm
                                            font-semibold
                                            text-white
                                            backdrop-blur-sm
                                            transition-all
                                            duration-300
                                            hover:-translate-y-1
                                            hover:border-[#D7A74A]/70
                                            hover:bg-white
                                            hover:text-[#0B5552]
                                        "
                                    >
                                        Compare Hotel Rates
                                    </button>

                                </div>


                                {/* =================================================
                                    TRUST POINTS
                                ================================================== */}

                                <div
                                    className="
                                        mt-9
                                        flex
                                        flex-wrap
                                        items-center
                                        gap-x-6
                                        gap-y-3
                                        text-xs
                                        text-white/65
                                    "
                                >

                                    <div className="flex items-center gap-2">

                                        <span
                                            className="
                                                flex
                                                h-5
                                                w-5
                                                shrink-0
                                                items-center
                                                justify-center
                                                rounded-full
                                                bg-[#D7A74A]/15
                                                text-[#D7A74A]
                                            "
                                        >
                                            <CheckIcon className="h-3.5 w-3.5" />
                                        </span>

                                        Best available rates

                                    </div>


                                    <span className="hidden h-4 w-px bg-white/15 sm:block" />


                                    <div className="flex items-center gap-2">

                                        <span
                                            className="
                                                flex
                                                h-5
                                                w-5
                                                shrink-0
                                                items-center
                                                justify-center
                                                rounded-full
                                                bg-[#D7A74A]/15
                                                text-[#D7A74A]
                                            "
                                        >
                                            <CheckIcon className="h-3.5 w-3.5" />
                                        </span>

                                        Trusted hotel choices

                                    </div>


                                    <span className="hidden h-4 w-px bg-white/15 sm:block" />


                                    <div className="flex items-center gap-2">

                                        <span
                                            className="
                                                flex
                                                h-5
                                                w-5
                                                shrink-0
                                                items-center
                                                justify-center
                                                rounded-full
                                                bg-[#D7A74A]/15
                                                text-[#D7A74A]
                                            "
                                        >
                                            <CheckIcon className="h-3.5 w-3.5" />
                                        </span>

                                        Secure booking

                                    </div>

                                </div>

                            </div>


                            {/* =================================================
                                RIGHT PREMIUM VISUAL
                            ================================================== */}

                            <div
                                className="
                                    relative
                                    min-h-[320px]
                                    overflow-hidden
                                    lg:min-h-[500px]
                                "
                            >

                                {/* Background */}
                                <div
                                    className="
                                        absolute
                                        inset-0
                                        bg-gradient-to-br
                                        from-[#123E3C]
                                        via-[#0B5552]
                                        to-[#073C3A]
                                    "
                                />


                                {/* Decorative circles */}
                                <div
                                    className="
                                        absolute
                                        -right-24
                                        -top-24
                                        h-72
                                        w-72
                                        rounded-full
                                        border
                                        border-[#D7A74A]/20
                                    "
                                />

                                <div
                                    className="
                                        absolute
                                        -bottom-24
                                        -left-24
                                        h-72
                                        w-72
                                        rounded-full
                                        border
                                        border-white/10
                                    "
                                />


                                {/* Center visual */}
                                <div
                                    className="
                                        absolute
                                        inset-0
                                        flex
                                        items-center
                                        justify-center
                                    "
                                >

                                    {/* Gold ring */}
                                    <div
                                        className="
                                            absolute
                                            h-64
                                            w-64
                                            rounded-full
                                            border
                                            border-[#D7A74A]/25
                                            sm:h-72
                                            sm:w-72
                                        "
                                    />

                                    <div
                                        className="
                                            absolute
                                            h-48
                                            w-48
                                            rounded-full
                                            border
                                            border-[#D7A74A]/15
                                            sm:h-56
                                            sm:w-56
                                        "
                                    />


                                    {/* Center card */}
                                    <div
                                        className="
                                            relative
                                            z-10
                                            w-[220px]
                                            rounded-2xl
                                            border
                                            border-white/15
                                            bg-white/10
                                            p-6
                                            text-center
                                            shadow-[0_20px_60px_rgba(0,0,0,0.20)]
                                            backdrop-blur-xl
                                            sm:w-[250px]
                                        "
                                    >

                                        <div
                                            className="
                                                mx-auto
                                                mb-4
                                                flex
                                                h-12
                                                w-12
                                                items-center
                                                justify-center
                                                rounded-full
                                                bg-[#D7A74A]
                                                text-[#0B5552]
                                                shadow-[0_8px_25px_rgba(215,167,74,0.25)]
                                            "
                                        >
                                            <SparklesIcon className="h-6 w-6" />
                                        </div>


                                        <p
                                            className="
                                                text-[10px]
                                                font-semibold
                                                uppercase
                                                tracking-[0.25em]
                                                text-[#D7A74A]
                                            "
                                        >
                                            Dubai Hotels
                                        </p>


                                        <h3
                                            className="
                                                mt-2
                                                font-serif
                                                text-2xl
                                                font-medium
                                                text-white
                                            "
                                        >
                                            Your next escape.
                                        </h3>


                                        <div className="mt-4 flex items-center justify-center gap-1">

                                            {[1, 2, 3, 4, 5].map((star) => (
                                                <span
                                                    key={star}
                                                    className="text-sm text-[#D7A74A]"
                                                >
                                                    ★
                                                </span>
                                            ))}

                                        </div>


                                        <p className="mt-2 text-xs text-white/55">
                                            Luxury stays across Dubai
                                        </p>

                                    </div>

                                </div>


                                {/* Floating badge */}
                                <div
                                    className="
                                        absolute
                                        bottom-6
                                        left-6
                                        rounded-xl
                                        border
                                        border-white/10
                                        bg-black/15
                                        px-4
                                        py-3
                                        backdrop-blur-md
                                        sm:bottom-8
                                        sm:left-8
                                    "
                                >

                                    <p className="text-[9px] uppercase tracking-[0.2em] text-[#D7A74A]">
                                        Book with confidence
                                    </p>

                                    <p className="mt-1 text-xs font-medium text-white">
                                        Luxury stays. Better rates.
                                    </p>

                                </div>


                                {/* Floating top badge */}
                                <div
                                    className="
                                        absolute
                                        right-6
                                        top-6
                                        rounded-full
                                        border
                                        border-[#D7A74A]/30
                                        bg-[#D7A74A]/10
                                        px-4
                                        py-2
                                        backdrop-blur-md
                                        sm:right-8
                                        sm:top-8
                                    "
                                >
                                    <span className="text-[10px] font-semibold uppercase tracking-[0.18em] text-[#D7A74A]">
                                        Dubai • UAE
                                    </span>
                                </div>

                            </div>

                        </div>

                    </div>


                    {/* =================================================
                        BOTTOM MINI TRUST BAR
                    ================================================== */}

                    <div
                        className="
                            flex
                            flex-col
                            items-center
                            justify-between
                            gap-4
                            border-t
                            border-[#E7E1D5]
                            bg-white
                            px-6
                            py-5
                            sm:flex-row
                            sm:px-10
                            lg:px-14
                        "
                    >

                        <div className="flex items-center gap-3">

                            <span
                                className="
                                    flex
                                    h-9
                                    w-9
                                    items-center
                                    justify-center
                                    rounded-full
                                    bg-[#0B5552]/5
                                    text-[#0B5552]
                                "
                            >
                                <CheckIcon className="h-4 w-4" />
                            </span>

                            <div>
                                <p className="text-xs font-semibold text-[#0B5552]">
                                    Simple. Secure. Reliable.
                                </p>

                                <p className="mt-0.5 text-[11px] text-[#6B7471]">
                                    Everything you need for a better Dubai stay.
                                </p>
                            </div>

                        </div>


                        <div className="flex items-center gap-2">

                            <span className="h-1.5 w-1.5 rounded-full bg-[#8B0000]" />

                            <span className="text-[11px] font-medium uppercase tracking-[0.18em] text-[#6B7471]">
                                Luxury stays • Dubai • Made simple
                            </span>

                        </div>

                    </div>

                </div>

            </div>

        </section>
    );
}